(function(){
  if(window.__sppCartRefinementsLoaded) return;
  window.__sppCartRefinementsLoaded = true;

  var PAGE_KEY = 'spp_continue_shopping_state';
  var RESTORE_KEY = 'spp_continue_shopping_restore';

  function currentPath(){
    return window.location.pathname + window.location.search + window.location.hash;
  }

  function isShoppingPage(value){
    try{
      var url = new URL(value, window.location.origin);
      if(url.origin !== window.location.origin) return false;
      return !/^\/(cart|checkout|checkouts|account)(\/|$)/i.test(url.pathname);
    }catch(e){
      return false;
    }
  }

  function readState(){
    try{
      var raw = sessionStorage.getItem(PAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    }catch(e){
      return null;
    }
  }

  function saveState(){
    if(!isShoppingPage(window.location.href)) return;
    try{
      sessionStorage.setItem(PAGE_KEY, JSON.stringify({
        url: currentPath(),
        scrollY: Math.max(0, Math.round(window.scrollY || window.pageYOffset || 0))
      }));
    }catch(e){}
  }

  function restorePositionIfNeeded(){
    if(!isShoppingPage(window.location.href)) return;
    try{
      if(sessionStorage.getItem(RESTORE_KEY) !== '1') return;
      var state = readState();
      sessionStorage.removeItem(RESTORE_KEY);
      if(!state || state.url !== currentPath()) return;
      var y = Number(state.scrollY || 0);
      requestAnimationFrame(function(){
        window.scrollTo(0, y);
        setTimeout(function(){ window.scrollTo(0, y); }, 80);
      });
    }catch(e){}
  }

  function getContinueUrl(){
    var state = readState();
    if(state && state.url && isShoppingPage(state.url)) return state.url;

    if(document.referrer && isShoppingPage(document.referrer)){
      try{
        var ref = new URL(document.referrer);
        return ref.pathname + ref.search + ref.hash;
      }catch(e){}
    }
    return '/collections/all';
  }

  function setContinueLinks(){
    if(!/^\/cart\/?$/i.test(window.location.pathname)) return;
    var destination = getContinueUrl();
    var links = document.querySelectorAll('.spp-cart__continue, .spp-continue-link');

    links.forEach(function(link){
      link.setAttribute('href', destination);
      if(link.dataset.sppContinueBound) return;
      link.dataset.sppContinueBound = '1';
      link.addEventListener('click', function(){
        try{ sessionStorage.setItem(RESTORE_KEY, '1'); }catch(e){}
      });
    });

    document.querySelectorAll('.spp-cart__btn').forEach(function(link){
      if(!/continue shopping/i.test(link.textContent || '')) return;
      link.setAttribute('href', destination);
      if(link.dataset.sppContinueBound) return;
      link.dataset.sppContinueBound = '1';
      link.addEventListener('click', function(){
        try{ sessionStorage.setItem(RESTORE_KEY, '1'); }catch(e){}
      });
    });
  }

  function replaceTextNodes(root){
    if(!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while((node = walker.nextNode())){
      var value = node.nodeValue || '';
      var updated = value
        .replace(/(?:Same-day\s+)?dispatch before 2pm/gi, 'Easy 14-Day Returns')
        .replace(/Fast Delivery/gi, 'Customer Support')
        .replace(/Free delivery over R2000(?!\*)/gi, 'Free delivery over R2000*')
        .replace(/WhatsApp support:\s*\+27\s*79\s*710\s*6449/gi, 'WhatsApp support available');
      if(updated !== value) node.nodeValue = updated;
    }
  }

  function renameTrustBadges(){
    var labels = ['Secure Checkout','14-Day Returns','Free Delivery*','Protected Payments'];
    document.querySelectorAll('#main-cart-footer .spp-cart-badge').forEach(function(badge, index){
      if(!labels[index]) return;
      var textNode = Array.prototype.find.call(badge.childNodes, function(node){
        return node.nodeType === Node.TEXT_NODE && (node.nodeValue || '').trim();
      });
      if(textNode) textNode.nodeValue = ' ' + labels[index] + ' ';
    });
  }

  function applyCartRefinements(){
    replaceTextNodes(document.querySelector('#main-cart-items'));
    replaceTextNodes(document.querySelector('#main-cart-footer'));
    renameTrustBadges();
    setContinueLinks();
  }

  function observeCart(){
    ['#main-cart-items','#main-cart-footer'].forEach(function(selector){
      var root = document.querySelector(selector);
      if(!root) return;
      var queued = false;
      new MutationObserver(function(){
        if(queued) return;
        queued = true;
        requestAnimationFrame(function(){
          queued = false;
          applyCartRefinements();
        });
      }).observe(root,{childList:true,subtree:true});
    });
  }

  function startPageMemory(){
    if(!isShoppingPage(window.location.href)) return;
    restorePositionIfNeeded();
    saveState();
    var ticking = false;
    window.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        ticking = false;
        saveState();
      });
    }, {passive:true});
    window.addEventListener('pagehide', saveState);
  }

  function ready(){
    startPageMemory();
    applyCartRefinements();
    observeCart();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
})();
